export default __webpack_public_path__ + "static/media/34t.3a6f1fa7.jpg";